import type { Media } from './media';
export enum ContentMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  EMBED = 'embed',
}

export enum ContentStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum VideoProcessingStatus {
  PENDING = 'pending',
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  READY = 'ready',
  FAILED = 'failed',
}

export enum EmbedProvider {
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
  MYTPI = 'mytpi',
  OTHER = 'other',
}

export interface ContentItem {
  id: string;
  title: string;
  description?: string;
  categoryIds: string[];
  tags: string[];
  archetypeIds: string[];
  tpiScreenIds: string[];
  sbGoalIds: string[];
  equipmentIds: string[];
  patternIds: string[];
  positionIds: string[];
  mediaType: ContentMediaType;
  imageUrl?: string;
  imageSignedUrl?: string;
  imageMedia?: Media;
  gumletAssetId?: string;
  videoProcessingStatus?: VideoProcessingStatus;
  videoPlaybackUrl?: string;
  videoThumbnailUrl?: string;
  videoDurationSeconds?: number;
  embedProvider?: EmbedProvider;
  embedUrl?: string;
  status: ContentStatus;
  publishedAt?: string;
  sets?: string;
  reps?: string;
  frequency?: string;
  intensity?: string;
  createdBy?: { userId: string; name: string };
  updatedBy?: { userId: string; name: string };
  createdAt: string;
  updatedAt: string;
}

// Mirrors CreateContentItemDto exactly — no server-owned fields (status,
// imageUrl, gumletAssetId, videoProcessingStatus, publishedAt, createdBy,
// updatedBy) may appear here.
export interface ContentItemFormData {
  title: string;
  description?: string;
  mediaType: ContentMediaType;
  categoryIds?: string[];
  tags?: string[];
  archetypeIds?: string[];
  tpiScreenIds?: string[];
  sbGoalIds?: string[];
  equipmentIds?: string[];
  patternIds?: string[];
  positionIds?: string[];
  embedProvider?: EmbedProvider;
  embedUrl?: string;
  sets?: string;
  reps?: string;
  frequency?: string;
  intensity?: string;
}

export interface ContentItemListParams {
  offset?: number;
  limit?: number;
  status?: ContentStatus;
  mediaType?: ContentMediaType;
  categoryId?: string;
  tag?: string;
  archetypeId?: string;
  tpiScreenId?: string;
  sbGoalId?: string;
  equipmentId?: string;
  patternId?: string;
  positionId?: string;
  search?: string;
}

export interface ContentItemListResult {
  data: ContentItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface VideoUploadTarget {
  uploadUrl: string;
  assetId: string;
}
